import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M22.793 14.38h-4.398a2.926 2.926 0 0 1-2.925-2.923 2.925 2.925 0 0 1 2.925-2.924h4.398M18.893 11.39h-.34",
      style: {"stroke":"inherit"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.701 2h9.39a5.7 5.7 0 0 1 5.702 5.701V15.5a5.7 5.7 0 0 1-5.701 5.701h-9.39A5.7 5.7 0 0 1 2 15.5V7.7a5.7 5.7 0 0 1 5.701-5.7",
      "clip-rule": "evenodd",
      style: {"stroke":"inherit"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M6.928 6.93h5.865",
      style: {"stroke":"inherit"}
    }, null, -1)
  ])))
}
export default { render: render }